(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
  // Initialize currentHandle if not already set
  if (typeof window.relatedProductsCurrentHandle === 'undefined') {
    window.relatedProductsCurrentHandle = window.location.pathname.split('/products/')[1];
  }

  // Named function for the event handler so we can remove it
  function handleSwatchClick(e) {
    const input = e.target.closest('.product__selectors .selector-wrapper--swatches [name="options[Color]"]');
    if (!input) {
      return;
    }

    const productUrl = input.dataset.productUrl;
    if (!productUrl) {
      return;
    }
    
    const handle = productUrl.split('/products/')[1]?.split('?')[0];
    if (handle === window.relatedProductsCurrentHandle) {
      return;
    }

    window.relatedProductsCurrentHandle = handle;

    const relatedSection = document.querySelector('[data-section-type="related-products"]');
    if (!relatedSection) {
      return;
    }

    const sectionId = relatedSection.dataset.sectionId;
    const limit = relatedSection.dataset.limit || 4;

    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => fetch(`/recommendations/products?product_id=${product.id}&limit=${limit}&section_id=${sectionId}`))
      .then(res => res.text())
      .then(html => {
        const shopifySection = document.getElementById(`shopify-section-${sectionId}`);
        if (shopifySection) {
          shopifySection.outerHTML = html;
        }
      })
      .catch(err => console.error('Related products fetch failed:', err));
  }

  // Remove existing listener if it exists to prevent duplicates
  // Have to attach the click event high up since the whole product blocks section is re-rendered via the section rendering API
  // when a swatch color is clicked, causing us to lose any click events we attach to the swatch radio buttons
  document.removeEventListener('click', handleSwatchClick);
  document.addEventListener('click', handleSwatchClick);

  } catch(e) { console.error(e); }
})();
})();
